module.exports = __webpack_public_path__ + "80b5bdd43ac75356f7b589b60facd1e1.png";